import { ErrorHandler, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Constants } from '../../../shared/const/constants';
import { AuthService } from '../auth.service';
import { ErrorHandlerInterface } from './error-handler.interface';

@Injectable()
export class UserErrorHandlerService implements ErrorHandlerInterface {
  constructor(private auth: AuthService, private router: Router) {}
  handleError(error: any): boolean {
    if (error.error === Constants.USER_NOT_FOUND) {
      this.auth.logout();
      this.router.navigate(['/account-disabled']);
      return true;
    }
    // Handle the 404 error here if needed.
    return false;
  }
}
